import { Component } from '@angular/core';
import { HttpService } from '../services/httpService';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-schedule',
  templateUrl: './schedule.component.html',
})
export class ScheduleComponent {





  scheduleType: string = "pratt";





  constructor(private httpService: HttpService, private activeRoute: ActivatedRoute) {

    this.scheduleType = decodeURI(this.activeRoute.snapshot.params['id']);







  }
}
